var constantData = {
  srpLeadFormMessages: {
    'header_message': 'We are here to serve you in the best way.',
    'lead_message': 'Your query will be sent to a Seller on Yatra or to the Yatra Team, who will connect with you, to help you plan your trip.',
    'consent_message': 'By submitting this form you give your consent to Yatra and its Sellers to connect with you regarding this query.',
    'tooltip_message': "By submitting this form, you authorize Yatra.com and its partners to contact you for this inquiry/transaction and that such a phone call will be 'transactional' as per 'Telecom Regulatory Authority of India' rules."
  },
  maxDestinationDispCount: 3
}
export default constantData



// WEBPACK FOOTER //
// ./src/common/constants.js